'use strict';
angular.module('newspaperSampleReviewModule', [
    'newspaperSampleReviewRouterModule',
    'editCenNewspaperSampleDetailModule',
    'newspaperSampleUploadModule',
])
    .controller('newspaperSampleReviewCtrl', ['$scope', '$state', '$q', '$filter', 'trsHttpService', 'trsspliceString', 'modalDialog', 'editcenterRightsService', 'editingCenterService', 'editNewspaperService', 'localStorageService', 'storageListenerService', 'publicToolService',
        function($scope, $state, $q, $filter, trsHttpService, trsspliceString, modalDialog, editcenterRightsService, editingCenterService, editNewspaperService, localStorageService, storageListenerService, publicToolService) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.params = {
                    serviceid: 'mlf_paper',
                    methodname: 'queryComposePageInfos',
                    PaperId: $state.params.paperid,
                    DieCi: '',
                    ViewStatusForQianFa: '-1',
                    ViewStatusForShenHe: '-1',
                };
                getSystemDate();
                $scope.status = {
                    selectedArray: [],
                    showHistoryList: false,
                };
                $scope.data = {
                };
                $scope.historyData = [];
                getRights();
                listenStorage();
            }

            /**
             * [getSystemDate description] 获取见报日期，0-8点取当天，
             * @return {[type]} [description]
             */
            function getSystemDate() {
                var date = new Date();
                var nowHour = date.getHours();
                date = (nowHour < 8) ? date : date.setDate(date.getDate() + 1);
                $scope.params.PubDate = $filter('date')(date, 'yyyy-MM-dd');
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                queryDieCis().then(function() {
                    $scope.params.DieCi = $scope.status.diecis.map(function(value, index) {
                        return value.CHANNELID;
                    }).join(',');
                    requestData();
                    datePickerWacher();
                });
                publicToolService.getModeconfiguration('IM').then((config) => {
                    $scope.status.IM = config;
                });
            }

            /**
             * [datePickerWacher description] 日期控件监控
             * @return {[type]} [description]
             */
            function datePickerWacher() {
                if (angular.isFunction($scope.status.watcher)) {
                    $scope.status.watcher();
                }
                $scope.status.watcher = $scope.$watch('params.PubDate', function(newV, oldV) {
                    if (newV === oldV) {
                        return;
                    }
                    if (angular.isDate(oldV)) {
                        return;
                    }
                    if (angular.isDate(newV)) {
                        $scope.params.PubDate = $filter('date')(newV, 'yyyy-MM-dd');
                    }
                    requestData();
                });
            }

            /**
             * [setDate description] 设置日期
             * @param {[type]} flag [description] 标识
             * @return  {[type]}   [return description]
             */
            $scope.setDate = function(flag) {
                var date = new Date(Date.parse($scope.params.PubDate));
                if (flag === 'prev') {
                    date.setDate(date.getDate() - 1);
                } else if (flag === 'next') {
                    date.setDate(date.getDate() + 1);
                } else {
                    date = new Date();
                }
                $scope.params.PubDate = $filter('date')(date, 'yyyy-MM-dd');
            };

            /**
             * [reviewOption description] 评审意见
             * @param  {[type]} item [description] 大样信息
             * @return {[type]}      [description]
             */
            $scope.reviewOption = function(item) {
                editNewspaperService.textDesignation(item.COMPOSEPAGEINFOID, item.DYFILEPATH, $scope.status.btnRights['paper.dysy.reviewopinions'], function() {
                    requestData();
                });
            };

            /**
             * [singleSelecte description]单选
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.singleSelecte = function(item) {
                var index = $scope.status.selectedArray.indexOf(item);
                if (index > -1) {
                    $scope.status.selectedArray.splice(index, 1);
                } else {
                    $scope.status.selectedArray.push(item);
                }
            };

            /**
             * [toDetail description] 到详情页
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.toDetail = function(item) {
                if (!$scope.status.btnRights['paper.dysy.chakan']) {
                    return;
                }
                try {
                    var data = $scope.status.showHistoryList ? angular.copy($scope.historyData) : angular.copy($scope.data.items);
                    localStorageService.remove('newspaperDYPreview');
                    data = data.map(function(value) {
                        var obj = angular.copy(value);
                        if (angular.isObject(value.FLOWRECORD)) {
                            obj.FLOWRECORD = value.FLOWRECORD.map(function(value_) {
                                return {
                                    OpreTime: value_.OpreTime,
                                    TrueName: value_.TrueName,
                                };
                            });
                        }
                        return obj;
                    });
                    localStorageService.set('newspaperDYPreview', JSON.stringify(data));
                } catch (e) {
                    console.log('数据结构缺失，可能无法翻页');
                } finally {
                    var href = $state.href('newspapersampledetail', {
                        status: item.STATUS,
                        composeId: item.COMPOSEPAGEINFOID,
                        DIECINAME: item.DIECINAME,
                        PAGENAME: item.FTPAGENAME || item.PAGENAME,
                        FTPUBDATE: item.FTPUBDATE,
                        paperid: $state.params.paperid,
                    });
                    window.open(href);
                }
            };

            /**
             * [getRights description] 获取操作权限
             * @return {[type]} [description]
             */
            function getRights() {
                // 按钮权限
                editcenterRightsService.initNewspaperListBtn('paper.dysy', $state.params.paperid).then(function(data) {
                    if (!data['paper.dysy.chakan']) {
                        modalDialog.alertType('', '您没有查看该页面的权限', 'error', false);
                        setTimeout(() => {
                            window.close();
                        }, 2000);
                    } else {
                        $scope.status.btnRights = data;
                    }
                });
            }

            /**
             * [reRresh description] 删除版面
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.delete = function() {
            	var ids = trsspliceString.spliceString($scope.status.selectedArray, 'STATUS', ',');
                if (ids.indexOf('39') > -1){
                    modalDialog.alertType('', '正在组版不能删除', 'error', false, function() {
                    });
                    return;
                }
                var params = {
                    serviceid: 'mlf_dymonitor',
                    methodname: 'removeDyFile',
                    PaperId: $state.params.paperid,
                    ComposePageInfoIds: $scope.status.selectedArray.map(function(value, index) {
                        return value.COMPOSEPAGEINFOID;
                    }).join(','),
                };
                modalDialog.confirmModal('删除', '确认删除', function() {
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(res) {
                        if (res.ISSUCCESS) {
                            modalDialog.alertType('删除成功！', '', 'success', false);
                            requestData();
                        }
                    });
                });
            };

            /**
             * [edit description] 编辑大样信息
             * @return {[type]} [description]
             */
            $scope.edit = function() {
                if ($scope.status.selectedArray.length > 1) {
                    modalDialog.alertType('', '大样只能单个编辑', 'error', false, function() {
                    });
                    return;
                } else {
                    var selectData = $scope.status.selectedArray[0];
                    var item = {
                        banPositon: selectData.PAGECODE,
                        banPositonId: selectData.PAGEID,
                        diePosition: selectData.DIECINAME,
                        diePositionId: selectData.DIECIID,
                        id: selectData.TENANTID || '',
                        imageName: '/wcm/imgcenter.do?ServiceId=mlf_paper&MethodName=findImageOfComposePage&Width=224&ComposeId=' + $scope.status.selectedArray[0].COMPOSEPAGEINFOID + '&random=' + $scope.status.selectedArray[0].RANDOMFORIMG,
                        imgSrc: '/wcm/imgcenter.do?ServiceId=mlf_paper&MethodName=findImageOfComposePage&Width=224&ComposeId=' + $scope.status.selectedArray[0].COMPOSEPAGEINFOID + '&random=' + +$scope.status.selectedArray[0].RANDOMFORIMG,
                        orignalImg: selectData.DYFILEPATH,
                        time: selectData.PUBDATE,
                        uploadTime: selectData.CRTIME,
                        zuPeople: selectData.OPRUSER_TNAME,
                    };
                    editNewspaperService.manualUpload($state.params.paperid, item, requestData);
                }
            };

            /**
             * [requestData description] 刷新列表
             * @return {[type]} [description]
             */
            function requestData() {
                $scope.status.selectedArray = [];
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                    data.map(function(value, index) {
                        value.RANDOMFORIMG = Math.random();
                        // 撤销点样---归类到组版暂停 取消签发---归类到组版完毕
                        value.STATUS_NAME_NEW = value.STATUS_NAME === '撤销点样' ? '暂停组版' : value.STATUS_NAME === '取消签发' ? '组版完毕' : value.STATUS_NAME;
                    });
                    $scope.data.items = data;
                });
            }

            /**
             * [queryDieCiByPaperId description]按照叠次查询列表
             * @return {[type]} [description]
             */
            function queryDieCis() {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_paper',
                    methodname: 'queryDieCis',
                    PaperId: $state.params.paperid,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.status.diecis = data;
                    deffer.resolve();
                });
                return deffer.promise;
            }

            /**
             * [selectedDieCi description] 选中叠次
             * @param  {[object]} dieci [description] 叠次信息
             * @return {[type]}       [description]
             */
            $scope.selectedDieCi = function(dieci) {
                var dieciArray = $scope.params.DieCi == '' ? [] : $scope.params.DieCi.split(',');
                var index = dieciArray.indexOf(dieci.CHANNELID);
                if (index >= 0) {
                    dieciArray.splice(index, 1);
                } else {
                    dieciArray.push(dieci.CHANNELID);
                }
                $scope.params.DieCi = dieciArray.join(',');
                requestData();
            };

            /**
             * [selectCondition description] 点击筛选条件
             * @param  {[type]} paramsName [description] 参数名称
             * @param  {[type]} value      [description] 参数值
             * @return {[type]}            [description]
             */
            $scope.selectCondition = function(paramsName, value) {
                $scope.params[paramsName] = $scope.params[paramsName] == value ? '-1' : value;
                requestData();
            };

            /**
             * [manualUpload description] 手动上传
             * @return {[type]} [description]
             */
            $scope.manualUpload = function() {
                editNewspaperService.manualUpload($state.params.paperid, '', requestData);
            };

            /**
             * [refresh description] 刷新页面
             * @return {[type]} [description]
             */
            $scope.refresh = function() {
                initStatus();
                initData();
            };

            /**
             * [sign description] 签发
             * @return {[type]} [description]
             */
            $scope.sign = function() {
                checkStatus('请只选择“组版完毕”状态的大样', '42,46').then(function(ids) {
                    var params = {
                        serviceid: 'mlf_paper',
                        methodname: 'dyExamine',
                        PaperId: $state.params.paperid,
                        ObjectIds: ids,
                        isPass: 'true',
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                        modalDialog.alertType('签发成功', '', 'success', false, function() {
                            requestData();
                        });
                    });
                });
            };

            /** YYY
             * [cancelSign description] 取消签发
             * @return {[type]} [description]
             */
            $scope.cancelSign = function() {
                checkSign('请只选择“已签发”状态的大样', '45').then(function(ids) {
                    var params = {
                        serviceid: 'mlf_paper',
                        methodname: 'dyExamine',
                        ObjectIds: ids,
                        PaperId: $state.params.paperid,
                        isPass: 'false',
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                        modalDialog.alertType('取消签发成功', '', 'success', false, function() {
                            requestData();
                        });
                    });
                });
            };

            /**
             * [checkSign description] 检查可签发/取消签发 的状态
             * @return {[type]} [description]
             */
            function checkSign(tip, status) {
                var deffer = $q.defer();
                var flag = false;
                for (var i in $scope.status.selectedArray) {
                    var item = $scope.status.selectedArray[i];
                    if (item.STATUS != status) {
                        flag = true;
                        break;
                    }
                }
                if (flag) {
                    modalDialog.alertType(tip, '', 'warning', 'confirm', function() {
                        deffer.reject();
                    });
                } else {
                    var objIds = $scope.status.selectedArray.map(function(value, index) {
                        return value.COMPOSEPAGEINFOID;
                    }).join(',');
                    deffer.resolve(objIds);
                }
                return deffer.promise;
            }
            
            /**
             * [checkStatus description] 判断大样状态
             * @param  {[string]} tip [description] 提示信息
             * @param  {[string]} status [description] 逗号分隔的状态码
             * @return {[type]} [description]
             */
            function checkStatus(tip, status) {
                var deffer = $q.defer();
                var flag = false;
                for (var i in $scope.status.selectedArray) {
                    var item = $scope.status.selectedArray[i];
                    if(status.indexOf(item.STATUS)==-1){
                        flag = true;
                    }
                    if(flag == true){
                        break;
                    }
                }
                if (flag) {
                    modalDialog.alertType(tip, '', 'warning', 'confirm', function() {
                        deffer.reject();
                    });
                } else {
                    var objIds = $scope.status.selectedArray.map(function(value, index) {
                        return value.COMPOSEPAGEINFOID;
                    }).join(',');
                    deffer.resolve(objIds);
                }
                return deffer.promise;
            }

            /**
             * [listenStorage description]监听本地缓存
             * @return {[promise]} [description] promise
             */
            function listenStorage() {
                storageListenerService.listenNewspaper(function() {
                    requestData();
                }, $scope);
            }

            /**
             * [enforcedUlock description] 强制解锁
             * @return {[type]} [description]
             */
            $scope.enforcedUlock = function() {
                checkSign('请只选择“正在组版”状态的大样', '39').then(function() {
                    modalDialog.alertType('确定要强制解锁么？', '', 'ask', true, function() {
                        var params = {
                            serviceid: 'mlf_paper',
                            methodname: 'stopDaYangCompose',
                            ComposeIds: trsspliceString.spliceString($scope.status.selectedArray, 'COMPOSEPAGEINFOID', ','),
                            PaperId: $state.params.paperid,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function() {
                            modalDialog.alertType('强制解锁成功！', '', 'success', false);
                            requestData();
                        });
                    });
                });
            };

            /**
             * [processRecordingView description] 查看组版记录
             * @param  {[object]} item [description] 大样信息
             * @return {[type]} [description]
             */
            $scope.processRecordingView = function(item) {
                editNewspaperService.processRecording(item);
            };

            /**
             * [downLoadPDF description] 下载PDF
             * @param  {[type]} item [description] 大样信息
             * @return {[type]}      [description]
             */
            $scope.downLoadPDF = function(item) {
                var params = {
                    PaperId: item.PAPERID,
                    ComposepageinfoId: item.COMPOSEPAGEINFOID,
                };
                trsHttpService.httpServer('/wcm/openapi/downloadComposePdf', params, 'get').then(
                    function() {
                        var url = window.location.origin + '/wcm/openapi/downloadComposePdf?PaperId=' + item.PAPERID + '&ComposepageinfoId=' + item.COMPOSEPAGEINFOID;
                        window.open(url);
                    },
                    function(error) {

                    });
            };

            /**
             * 整版转板
             */
            $scope.turntable = function() {
            	checkStatus('请只选择“组版完毕”状态的大样', '42,46').then(function(ids){
                    var transferData = {
                        selectedArr: $scope.status.selectedArray,
                    };
                    editNewspaperService.changeAllLayoutDraft(transferData, function(result) {
                        var params = {
                            serviceid: 'nb_ft',
                            methodname: 'doWholeZhuanBan',
                            OrlPubDate: $filter('date')(new Date($scope.status.selectedArray[0].PUBDATE), 'yyyy-MM-dd'),
                            OrlPageId: $scope.status.selectedArray[0].PAGEID,
                            PaperId: $scope.status.selectedArray[0].PAPERID,
                            ToPubDate: result.dateStr,
                            Option: result.option,
                            ToPageId: result.banmianid,
                            ComposePageInfoId: $scope.status.selectedArray[0].COMPOSEPAGEINFOID,
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(res) {
                            if (res.ISSUCCESS === 'true') {
                                modalDialog.alertType(res.DETAIL, '', 'success', false);
                                requestData();
                            } else {
                                modalDialog.alertType(res.msg, '', 'error', false);
                            }
                        });
                    });
                });
            };

            /**
             * [downLoadPDF description] 调转到历史版面
             * @param  {[type]} item [description] 大样信息
             * @return {[type]}      [description]
             */
            $scope.showHistory = function(item) {
                $scope.status.showHistoryList = true;
                var params = $scope.params;
                params.LoadComposeVersion = true;
                params.ComposepageinfoId = item.COMPOSEPAGEINFOID;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(res) {
                    $scope.historyData = res;
                });

            };
            $scope.back = function() {
                $scope.status.showHistoryList = false;
                delete $scope.params.LoadComposeVersion;
                delete $scope.params.ComposepageinfoId;

            };

            /**
             * [sendmessage 发送到IM]
             *
             * @return  {[type]}  [return description]
             */
            $scope.sendmessage = function() {
                let messageBody = [];
                let messageType = 'DA_YANG';
                let outerSourceId = '';
                $scope.status.selectedArray.map((item) => {
                    // const previewUrl = window.location.origin + '/xjmediaCloud/#/' + `sampledetail?composeId=${item.COMPOSEPAGEINFOID}&DIECINAME=${item.DIECINAME}&PAGENAME=${item.PAGENAME}&paperid=${item.PAPERID}&status=${item.STATUS}`;
                    let extraInfo = angular.extend(item, {
                        daYangPic: '/wcm/imgcenter.do?ServiceId=mlf_paper&MethodName=findImageOfComposePage&Width=224&ComposeId=' + item.COMPOSEPAGEINFOID + '&random=' + item.RANDOMFORIMG,
                        oprType: 'paper.dysy'
                    });
                    let message = {
                        content: '',
                        extraInfo: JSON.stringify(extraInfo),
                        messageType: messageType, 
                        outerSourceId: outerSourceId,
                        title: item.DIECINAME + '-' + item.PAGENAME
                    };
                    messageBody.push(message);
                });
                const info = {
                    messageBody: messageBody,
                    outerSourceId: '',
                    oprType: 'paper.dysy',
                    objId: $state.params.paperid
                };
                editingCenterService.sendToStudio(info);
            };

        },
    ]);
